var _style, _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F0F0F0;}\n\t.st1{fill:#338AF3;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 256,
    cy: 256,
    r: 256
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256,512c101.5,0,189.2-59.1,230.6-144.7H25.4C66.8,452.9,154.5,512,256,512z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256,0C154.5,0,66.8,59.1,25.4,144.7h461.2C445.2,59.1,357.5,0,256,0L256,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M157.5,167l8.3,25.5h26.8L171,208.2l8.3,25.5L157.5,218l-21.7,15.8l8.3-25.5l-21.7-15.8h26.8L157.5,167z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M157.5,278.3l8.3,25.5h26.8L171,319.5l8.3,25.5l-21.7-15.8L135.8,345l8.3-25.5l-21.7-15.8h26.8L157.5,278.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M354.5,167l8.3,25.5h26.8l-21.7,15.8l8.3,25.5L354.5,218l-21.7,15.8l8.3-25.5l-21.7-15.8h26.8L354.5,167z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M354.5,278.3l8.3,25.5h26.8l-21.7,15.8l8.3,25.5l-21.7-15.8L332.8,345l8.3-25.5l-21.7-15.8h26.8L354.5,278.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256,222.6l8.3,25.5h26.8l-21.7,15.8l8.3,25.5L256,273.6l-21.7,15.8l8.3-25.5l-21.7-15.8h26.8L256,222.6z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHn);
export default __webpack_public_path__ + "static/media/hn.41fcdc973aee7997b33f8dc5acb272fe.svg";
export { ForwardRef as ReactComponent };